import React, {useEffect, useState} from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Theme,
  Typography
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {formatDate, formatPeso, hasPermissionTo, PERSMISOS} from "../../helpers";
import {useLocation, useNavigate} from "react-router-dom";
import Strings from "../../assets/strings";
import {IIngreso} from "../../redux/types/IIngreso";
import {ConfirmDialog, TopBarDialog} from "../../components";
import {eliminarIngreso} from "../../redux/reducers/ingresosReducers";
import {useAppDispatch} from "../../redux/hooks";
import {getIngresoById} from "../../services";
import LoadingProgress from "../../components/LoadingProgress";

const useStyles = makeStyles((theme:Theme) => ({
  root:{
    minWidth:300
   // zIndex:theme.zIndex.modal + 1,
   //  background: "white",
   //  position: "absolute",
   //  bottom: 0,
   //  width: "100%",
  //  textAlign: "center",
  },
  comment:{
    padding: "8px 16px",
    // fontSize: ".8rem",
    "& p":{
      fontWeight: 'normal',
      color:theme.palette.text.secondary,
      margin: 0,
      fontSize: "0.9em",
    }
  },
}));
// const TranUp = SlideTransition("up");

export default function DetallesIngreso({allowDelete}:{allowDelete?:boolean}) {
  const classes = useStyles();
  const {state:urlState={}, pathname} = useLocation();
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [ingreso, setIngreso] = useState<IIngreso>();
  const dispatch = useAppDispatch();

  let close = ()=>{
    navigate(-1)
  }


  useEffect(() => {
    if(urlState?.detalleIngreso?.id){
      if(urlState?.detalleIngreso?.fecha){
        setIngreso(urlState.detalleIngreso)
      }else{
        setLoading(true)
        getIngresoById(urlState?.detalleIngreso?.id).then(({data})=>{
          setIngreso(data)
        }).finally(()=>setLoading(false))
      }
    }else{
      setIngreso(undefined)
    }
  }, [urlState,setLoading, setIngreso]);



  return <>
    <Dialog open={!!ingreso?.id} onClose={close} maxWidth={"sm"}>
      {/*TransitionComponent={TranUp}*/}
      <TopBarDialog title={Strings.ingreso} onClose={close} nofullScreen/>
      <DialogContent>
        {loading && <LoadingProgress/>}

        {!!ingreso &&
            <div className={classes.root}>
              <Table size={"small"} className={"noHover"}>
                <TableBody>
                  <TableRow>
                    <TableCell><Typography color={"primary"} fontWeight={500}>{Strings.monto}</Typography></TableCell>
                    <TableCell><Typography color={"primary"} fontWeight={500}>{formatPeso(ingreso.monto)}</Typography></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><Typography variant={"body2"} fontWeight={500}>{Strings.fecha}</Typography></TableCell>
                    <TableCell>{formatDate(ingreso.fecha,"LL")}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><Typography variant={"body2"} fontWeight={500}>{Strings.categoria}</Typography></TableCell>
                    <TableCell>{ingreso.categoria}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><Typography variant={"body2"} fontWeight={500}>{Strings.concepto}</Typography></TableCell>
                    <TableCell>{ingreso.concepto}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><Typography variant={"body2"} fontWeight={500}>{Strings.caja}</Typography></TableCell>
                    <TableCell>{ingreso.caja}</TableCell>
                  </TableRow>
                  {/*<li>*/}
                  {/*  <h6>{Strings.creadoPor}</h6>*/}
                  {/*  <span>{ingreso.creadoPor}</span>*/}
                  {/*</li>*/}
                </TableBody>
              </Table>
              {ingreso.comentario &&
                  <div className={classes.comment}>
                    <Typography variant={"body2"}>{Strings.comentario}</Typography>
                    {ingreso.comentario}
                  </div>
              }
            </div>
        }

      </DialogContent>
      {allowDelete && hasPermissionTo(PERSMISOS.ingresosEliminar) && !ingreso?.fechaAnulacion &&
        <Box display={"flex"} justifyContent={"center"} mb={1}>
          <Button
              onClick={()=>{navigate(pathname,{state:{...urlState, confirmDialog:{delIngreso:ingreso!.id}}})}}
              size={"small"}
              color={"error"}
              sx={{textTransform:"capitalize"}}>
            {(Strings.eliminar+" "+Strings.ingreso).toLowerCase()}
          </Button>
        </Box>
      }

    </Dialog>

    {urlState?.confirmDialog?.delIngreso &&
      <ConfirmDialog onConfirm={()=>dispatch(eliminarIngreso(urlState?.confirmDialog.delIngreso))}/>
    }

  </>;
}
